import {Card as JoyCard, CardProps} from "@mui/joy"

const Card = (props: CardProps) => {
    return <JoyCard  {...props}
                     variant={"outlined"}
                     sx={{
                         backgroundColor: "rgba(255,255,255,0.05)",
                         borderRadius: 15,
                         padding: {xs: 2, sm: 3},
                         gap:2,
                         borderColor: "rgba(255,255,255,0.1)",
                         ...props.sx
                     }}>
        {props.children}
    </JoyCard>
}

export default Card